import { GsFormField, GsFormIf } from '../components';
import { GsStructHorizontalAlignment, GsStructVerticalAlignment } from '../models';
import { borderSchemaFields } from './components/basics/border.schema';
import { alignmentSchema } from './components/page/alignment.schema';

/**
 * Shows a field only while the components do not fill the block height. Compared with `!= true`
 * because stored blocks often carry an unset (null) value, which the renderer treats as false.
 */
const IF_NOT_FILL_COMPONENT_HEIGHT: GsFormIf = {
  args: [
    {
      formControlName: 'fillComponentHeight',
      operator: '!=',
      value: true
    }
  ]
};

export const BLOCK_SCHEMA: GsFormField<unknown>[] = [
  {
    formControlName: 'clientId',
    type: 'control',
    default: 'shouldBeGenerated'
  },
  {
    formControlName: 'columns',
    type: 'column-width',
    label: 'schema.block.width.name',
    description: 'schema.block.width.description',
    isResponsive: true,
    default: {
      default: 12
    },
    min: 1,
    max: 12
  },
  {
    formControlName: 'lang',
    type: 'select',
    label: 'schema.block.language.name',
    description: 'schema.block.language.description',
    options: [{ text: 'English', value: 'en' }],
    default: 'en',
    valueType: 'string'
  },
  {
    formControlName: 'fillComponentHeight',
    type: 'checkbox',
    label: 'schema.block.fillComponentHeight.name',
    isResponsive: true,
    default: { default: false },
    description: 'schema.block.fillComponentHeight.description',
    groupingName: 'schema.block.alignment'
  },
  alignmentSchema('vertical', '', GsStructVerticalAlignment.top, 'schema.block.alignment', IF_NOT_FILL_COMPONENT_HEIGHT),
  alignmentSchema('horizontal', '', GsStructHorizontalAlignment.center, 'schema.block.alignment'),
  {
    formControlName: 'allowComponentNeighboring',
    type: 'checkbox',
    label: 'schema.block.allowComponentNeighboring.name',
    default: false,
    description: 'schema.block.allowComponentNeighboring.description',
    groupingName: 'schema.block.alignment',
    if: IF_NOT_FILL_COMPONENT_HEIGHT
  },
  {
    formControlName: 'backgroundColor',
    type: 'color',
    label: 'schema.block.backgroundColor',
    default: 'light-main'
  },
  ...borderSchemaFields()
];
